import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { FollowBrandButton as StyledFollowBrandButton } from '@bnnvara/buttons';
import React, { useContext } from 'react';

import { useNotifications } from '../../hooks/notifications';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import Notification from '../Notification';
import { Copy } from './Copy';
import { createNotification } from './createNotification';
import { FollowBrandContext } from './FollowBrandContext';
import * as S from './styled';
import { useIsFollowedByUser } from './useIsFollowedByUser';

const FollowBrand = () => {
  const brand = useBrand();
  const { followedBrands } = useContext(FollowBrandContext);
  const { isFollowedByUser, toggle } = useIsFollowedByUser(brand.id);
  const isDesktop = useIsDesktop();
  const hasSubscriptions = Boolean(followedBrands?.length);
  const { addNotification } = useNotifications();

  async function handleClick() {
    const result = await toggle();

    if (result === true) {
      addNotification(
        createNotification({
          hasSubscriptions,
          slug: brand.slug,
          brandName: brand.name,
        })
      );

      track('header', 'click', 'volgen');
    } else if (result === false) {
      track('header', 'click', 'ontvolgen');
    }
  }

  return (
    <S.NotificationPosition>
      <S.FollowButtonContainer>
        <StyledFollowBrandButton
          onClick={handleClick}
          isFollowedByUser={isFollowedByUser}
        />
      </S.FollowButtonContainer>
      <S.NotificationContainer>
        {!isFollowedByUser && (
          <Notification
            visible
            type="bnnvaraFollowBrandNotification"
            horizontalPosition={isDesktop ? 'left' : 'up'}
            direction={isDesktop ? 'left' : 'up'}
            delay={1000}
            hideAfter={7000}
            onlyShowOnceEvery24Hrs
            showCloseButton={false}
          >
            {Copy}
          </Notification>
        )}
      </S.NotificationContainer>
    </S.NotificationPosition>
  );
};

export default FollowBrand;
